import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import QuoteForm from '../../components/feature/QuoteForm';
import { Link } from 'react-router-dom';

export default function Contact() {
  return (
    <div className="min-h-screen bg-white" style={{ fontFamily: 'Inter, sans-serif' }}>
      <Navbar />

      {/* Hero Section */}
      <section className="relative pt-24 sm:pt-32 pb-12 sm:pb-20 bg-gradient-to-br from-gray-900 via-gray-800 to-gray-900 text-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center">
            <p className="text-primary-400 text-xs sm:text-sm mb-3 sm:mb-4 tracking-wider">Home / Contact</p>
            <h1 className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-black mb-4 sm:mb-6 leading-tight" style={{ fontFamily: 'Space Grotesk, sans-serif' }}>
              CONTACT US
            </h1>
            <p className="text-base sm:text-lg md:text-xl text-gray-300 max-w-3xl mx-auto leading-relaxed px-4">
              Get your free paving estimate today. We're here to help with all your asphalt and concrete needs in Lincoln, NE.
            </p>
          </div>
        </div>
      </section>

      {/* Contact Content */}
      <section className="py-12 sm:py-16 md:py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 sm:gap-12 mb-12 sm:mb-16">
            {/* Contact Form */}
            <div>
              <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold mb-4 sm:mb-6 text-gray-900 leading-tight" style={{ fontFamily: 'Space Grotesk, sans-serif' }}>
                Request Your Free Quote
              </h2>
              <p className="text-gray-700 text-base sm:text-lg leading-relaxed mb-6 sm:mb-8">
                Fill out the form below and we'll contact you within 24 hours to schedule your free on-site estimate. Whether you need asphalt repair, concrete driveway installation, or commercial paving services in Lincoln, we're here to help.
              </p>
              <QuoteForm variant="light" />
            </div>

            {/* Contact Information */}
            <div>
              <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold mb-4 sm:mb-6 text-gray-900 leading-tight" style={{ fontFamily: 'Space Grotesk, sans-serif' }}>
                Get In Touch
              </h2>
              <p className="text-gray-700 text-base sm:text-lg leading-relaxed mb-6 sm:mb-8">
                Have questions about your paving project? Our experienced team is ready to provide expert advice and honest answers. Contact us today for immediate assistance.
              </p>

              <div className="space-y-4 sm:space-y-6 mb-6 sm:mb-8">
                <div className="flex items-start space-x-3 sm:space-x-4">
                  <div className="w-12 h-12 bg-primary-100 rounded-full flex items-center justify-center flex-shrink-0">
                    <i className="ri-phone-line text-xl sm:text-2xl text-primary-600"></i>
                  </div>
                  <div>
                    <h3 className="font-bold text-gray-900 mb-1 text-base sm:text-lg">Phone</h3>
                    <a href="tel:3084705637" className="text-primary-600 text-base sm:text-lg font-semibold hover:text-primary-700 cursor-pointer">
                      (308) 470-5637
                    </a>
                    <p className="text-gray-600 text-xs sm:text-sm mt-1">Monday - Friday: 7:00 AM - 6:00 PM</p>
                  </div>
                </div>

                <div className="flex items-start space-x-3 sm:space-x-4">
                  <div className="w-12 h-12 bg-primary-100 rounded-full flex items-center justify-center flex-shrink-0">
                    <i className="ri-mail-line text-xl sm:text-2xl text-primary-600"></i>
                  </div>
                  <div>
                    <h3 className="font-bold text-gray-900 mb-1 text-base sm:text-lg">Email</h3>
                    <a href="mailto:info@lincolnasphalt.com" className="text-primary-600 text-base sm:text-lg font-semibold hover:text-primary-700 cursor-pointer break-all">
                      info@lincolnasphalt.com
                    </a>
                    <p className="text-gray-600 text-xs sm:text-sm mt-1">We respond within 24 hours</p>
                  </div>
                </div>

                <div className="flex items-start space-x-3 sm:space-x-4">
                  <div className="w-12 h-12 bg-primary-100 rounded-full flex items-center justify-center flex-shrink-0">
                    <i className="ri-map-pin-line text-xl sm:text-2xl text-primary-600"></i>
                  </div>
                  <div>
                    <h3 className="font-bold text-gray-900 mb-1 text-base sm:text-lg">Address</h3>
                    <p className="text-gray-700 text-sm sm:text-base">
                      123 Paving Street<br />
                      Lincoln, NE 68501
                    </p>
                  </div>
                </div>

                <div className="flex items-start space-x-3 sm:space-x-4">
                  <div className="w-12 h-12 bg-primary-100 rounded-full flex items-center justify-center flex-shrink-0">
                    <i className="ri-time-line text-xl sm:text-2xl text-primary-600"></i>
                  </div>
                  <div>
                    <h3 className="font-bold text-gray-900 mb-1 text-base sm:text-lg">Business Hours</h3>
                    <p className="text-gray-700 text-sm sm:text-base">
                      Monday - Friday: 7:00 AM - 6:00 PM<br />
                      Saturday: 8:00 AM - 4:00 PM<br />
                      Sunday: Closed
                    </p>
                  </div>
                </div>
              </div>

              <div className="bg-gradient-to-br from-red-50 to-orange-50 border-2 border-red-200 rounded-xl p-4 sm:p-6">
                <h3 className="font-bold text-gray-900 mb-2 sm:mb-3 text-base sm:text-lg flex items-center">
                  <i className="ri-alert-line text-red-600 text-xl mr-2"></i>
                  Emergency Services
                </h3>
                <p className="text-gray-700 mb-3 sm:mb-4 text-sm sm:text-base">
                  Need urgent pothole repair or emergency asphalt services? We offer same-day emergency repairs for critical situations.
                </p>
                <a href="tel:3084705637" className="inline-block bg-red-600 text-white px-4 sm:px-6 py-3 rounded-lg font-semibold hover:bg-red-700 transition-colors whitespace-nowrap cursor-pointer min-h-[56px] flex items-center justify-center text-sm sm:text-base w-full sm:w-auto">
                  CALL FOR EMERGENCY SERVICE
                </a>
              </div>
            </div>
          </div>

          {/* Map Section */}
          <div className="mb-12 sm:mb-16">
            <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold mb-4 sm:mb-6 text-gray-900 text-center leading-tight" style={{ fontFamily: 'Space Grotesk, sans-serif' }}>
              Visit Our Location
            </h2>
            <div className="rounded-2xl overflow-hidden shadow-2xl">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d97647.35204227841!2d-96.78279684999999!3d40.8136!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x8796be59ca561265%3A0x633a859b1fd5deb9!2sLincoln%2C%20NE!5e0!3m2!1sen!2sus!4v1234567890"
                width="100%"
                height="300"
                className="sm:h-[400px] md:h-[450px]"
                style={{ border: 0 }}
                allowFullScreen
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                title="Lincoln NE asphalt concrete paving location map"
              ></iframe>
            </div>
          </div>

          {/* Service Areas */}
          <div className="bg-gradient-to-br from-primary-50 to-orange-50 rounded-2xl p-6 sm:p-8 md:p-12 border border-primary-100">
            <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold mb-4 sm:mb-6 text-gray-900 text-center leading-tight" style={{ fontFamily: 'Space Grotesk, sans-serif' }}>
              Serving All of Lincoln & Lancaster County
            </h2>
            <p className="text-gray-700 text-base sm:text-lg text-center mb-6 sm:mb-8 max-w-3xl mx-auto">
              We provide professional asphalt and concrete paving services throughout Lincoln, Nebraska and surrounding areas. No job is too big or too small.
            </p>
            <div className="grid grid-cols-2 md:grid-cols-4 gap-4 sm:gap-6">
              <div className="text-center bg-white rounded-lg p-4 shadow-sm">
                <i className="ri-map-pin-line text-2xl sm:text-3xl text-primary-600 mb-2"></i>
                <p className="font-semibold text-gray-900 text-sm sm:text-base">Downtown Lincoln</p>
              </div>
              <div className="text-center bg-white rounded-lg p-4 shadow-sm">
                <i className="ri-map-pin-line text-2xl sm:text-3xl text-primary-600 mb-2"></i>
                <p className="font-semibold text-gray-900 text-sm sm:text-base">East Lincoln</p>
              </div>
              <div className="text-center bg-white rounded-lg p-4 shadow-sm">
                <i className="ri-map-pin-line text-2xl sm:text-3xl text-primary-600 mb-2"></i>
                <p className="font-semibold text-gray-900 text-sm sm:text-base">West Lincoln</p>
              </div>
              <div className="text-center bg-white rounded-lg p-4 shadow-sm">
                <i className="ri-map-pin-line text-2xl sm:text-3xl text-primary-600 mb-2"></i>
                <p className="font-semibold text-gray-900 text-sm sm:text-base">South Lincoln</p>
              </div>
              <div className="text-center bg-white rounded-lg p-4 shadow-sm">
                <i className="ri-map-pin-line text-2xl sm:text-3xl text-primary-600 mb-2"></i>
                <p className="font-semibold text-gray-900 text-sm sm:text-base">North Lincoln</p>
              </div>
              <div className="text-center bg-white rounded-lg p-4 shadow-sm">
                <i className="ri-map-pin-line text-2xl sm:text-3xl text-primary-600 mb-2"></i>
                <p className="font-semibold text-gray-900 text-sm sm:text-base">Lancaster County</p>
              </div>
              <div className="text-center bg-white rounded-lg p-4 shadow-sm">
                <i className="ri-map-pin-line text-2xl sm:text-3xl text-primary-600 mb-2"></i>
                <p className="font-semibold text-gray-900 text-sm sm:text-base">Surrounding Areas</p>
              </div>
              <div className="text-center bg-white rounded-lg p-4 shadow-sm">
                <i className="ri-map-pin-line text-2xl sm:text-3xl text-primary-600 mb-2"></i>
                <p className="font-semibold text-gray-900 text-sm sm:text-base">Commercial Districts</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}